"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAreFilesUploading = exports.getUploadingFiles = void 0;

var _reselect = require("reselect");

var _Files = require("./Files");

var getUploadingFiles = function getUploadingFiles(state) {
  return state.uploadingFiles.get('files');
};

exports.getUploadingFiles = getUploadingFiles;
var getAreFilesUploading = (0, _reselect.createSelector)([getUploadingFiles, _Files.getAreFilesBeingReplaced], function (uploadingFiles, areFilesBeingReplaced) {
  return !uploadingFiles.isEmpty() || areFilesBeingReplaced;
});
exports.getAreFilesUploading = getAreFilesUploading;